import { useState } from 'react';

import { useAppSelector } from 'features/app/hooks';
import type { DialedNumbersList } from 'features/dialed-numbers-history/interfaces';
import { dialedNumbersListSelector } from 'features/dialed-numbers-history/store';
import { maskPhoneNumber } from 'features/phone-number/helpers';

interface UseDialedNumbersHistoryOptions {
  /** Receives each stored (unmasked) number; entries returning true are hidden. */
  isExcluded?: (phoneNumber: string) => boolean;
}

export const useDialedNumbersHistory = ({
  isExcluded,
}: UseDialedNumbersHistoryOptions = {}) => {
  const [isOpenHistory, setIsOpenHistory] = useState(false);
  const unMaskedDialedNumbersList = useAppSelector(dialedNumbersListSelector);

  const dialedNumbersList: DialedNumbersList = unMaskedDialedNumbersList
    .filter((phoneNumber) => !isExcluded?.(phoneNumber))
    .map(maskPhoneNumber);

  return {
    isOpenHistory,
    setIsOpenHistory,
    dialedNumbersList,
  };
};
